import miniGamesService from '../../entities/miniGames';
import logger from '../../shares/lib/logger';

export const MiniGames = {
  launch: async (): Promise<void> => {
    try {
      await miniGamesService();
    } catch (error) {
      logger.error('MiniGames launch error', { error });
      throw error;
    }
  },

  remove: async (): Promise<void> => {
    // console.log('MiniGames removed');
  },
};
